module.exports = __webpack_public_path__ + "img/aop.a56fad59.svg";